import type { ApiExplorerTheme } from '@angular-workspace/feature';

/** MahaAgX brand colors for the shared API Explorer component. */
export const MAHAAGX_API_EXPLORER_THEME: ApiExplorerTheme = {
  accent: '#11634f',
  accent10: 'rgba(17, 99, 79, 0.12)',
  accent15: '#e2f1ea',
  accent20: 'rgba(17, 99, 79, 0.2)',
  primaryColor: '#00d084',
  primaryButtonGradientEnd: '#059669',
  textDark: '#0f172a',
  textSecondary: '#4b5563',
  borderColor: '#d7e5df',
  bgLight: '#f7fcfa',
  surface: '#ffffff',
  modalBackground: 'linear-gradient(180deg, #f8fbf9 0%, #ffffff 100%)',
  operationsPanelBorder: '#e2f1ea',
  operationsPanelBackground: 'linear-gradient(180deg, #f7fcfa 0%, #eef8f3 100%)',
  responseCardBorder: '#dfeee7',
  responseCardBackground:
    'linear-gradient(180deg, rgba(245, 251, 248, 0.9) 0%, rgba(255, 255, 255, 1) 24%), #ffffff',
  cardBorder: '#def0e8',
  cardBackground: 'rgba(255, 255, 255, 0.9)',
  cardActiveBorder: '#9edec0',
  cardActiveBackground: 'linear-gradient(180deg, #f2fff8 0%, #ffffff 100%)',
  cardActiveShadow: 'rgba(17, 99, 79, 0.12)',
  cardActiveSummaryBackground: 'linear-gradient(180deg, #eafbf2 0%, #f6fffa 100%)',
  cardActiveText: '#0d5440',
  summaryBackground: 'linear-gradient(180deg, #fcfffd 0%, #f7fcfa 100%)',
  dialogHeaderBorder: '#e7efeb',
  focusRing: 'rgba(17, 99, 79, 0.12)',
};
